import React from 'react';
import { PageContent } from 'shared/components/PageContent';
import { ScrollableViewport } from '@ihsm/ui-shared';
import { JobsSearch } from '../components/JobsSearch';
import { JobsList } from '../components/JobsList';
import { JobsHeader } from '../components/JobsHeader';
import { JOB_HEADER_COLUMNS } from '../constants';
import { useJobsPage } from '../hooks';
import './Jobs.scss';

export const Jobs: React.FC = () => {
  const {
    todayList,
    yesterdayList,
    olderList,
    isError,
    isLoading,
    onViewReport,
    onDropdownChange,
  } = useJobsPage();

  return (
    <div className="jobs-page">
      <PageContent
        forceNoDataScreen={isError}
        forceLoadingScreen={isLoading}
        searchTree={<JobsSearch />}
      >
        <JobsHeader headers={JOB_HEADER_COLUMNS} />

        <ScrollableViewport vertical>
          <JobsList
            todayList={todayList}
            yesterdayList={yesterdayList}
            olderList={olderList}
            onDropdownChange={onDropdownChange}
            onViewReport={onViewReport}
          />
        </ScrollableViewport>
      </PageContent>
    </div>
  );
};
